import React from 'react';
import { useTheme, useMediaQuery } from '@material-ui/core';
import { TrainersListviewDesktop } from './trainers-listview.desktop';
import { TrainersListviewMobile } from './trainers-listview.mobile';

export const TrainersListview = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  return isDesktop ? <TrainersListviewDesktop /> : <TrainersListviewMobile />;
};
